import { Inventory, InventoryItem } from '@/types';

const baseUrl =
	(import.meta.env.VITE_API_BASE_URL as string | undefined) ||
	'https://kht82zjoz6.execute-api.ap-southeast-2.amazonaws.com/dev';

async function http<T>(path: string, options: RequestInit): Promise<T> {
	const res = await fetch(`${baseUrl}${path}`, {
		...options,
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {})
		}
	});
	if (!res.ok) {
		const contentType = res.headers.get('content-type') || '';
		try {
			if (contentType.includes('application/json')) {
				const data = (await res.json()) as any;
				const msg =
					(typeof data?.message === 'string' && data.message) ||
					(typeof data?.error === 'string' && data.error) ||
					JSON.stringify(data);
				throw new Error(msg || `Request failed: ${res.status}`);
			} else {
				const text = await res.text();
				throw new Error(text || `Request failed: ${res.status}`);
			}
		} catch (e: any) {
			throw new Error(e?.message || `Request failed: ${res.status}`);
		}
	}
	return await res.json();
}

// Mock inventory data for now - in a real app, this would come from a backend API
const mockInventory: Inventory = {
	items: [
		{
			id: '1',
			name: 'Cascade Hops',
			category: 'hops',
			quantity: 100,
			unit: 'g',
			expirationDate: '2025-03-15',
			userId: 'user-1',
			createdAt: '2025-01-01T00:00:00Z',
			updatedAt: '2025-01-01T00:00:00Z'
		},
		{
			id: '2',
			name: 'Pale Ale Malt',
			category: 'malt',
			quantity: 5,
			unit: 'kg',
			userId: 'user-1',
			createdAt: '2025-01-01T00:00:00Z',
			updatedAt: '2025-01-01T00:00:00Z'
		},
		{
			id: '3',
			name: 'Safale US-05',
			category: 'yeast',
			quantity: 2,
			unit: 'pack',
			expirationDate: '2025-04-20',
			userId: 'user-1',
			createdAt: '2025-01-01T00:00:00Z',
			updatedAt: '2025-01-01T00:00:00Z'
		}
	],
	totalItems: 3,
	categories: {
		hops: 1,
		malt: 1,
		yeast: 1,
		equipment: 0,
		other: 0,
		additives: 0
	}
};

export const InventoryService = {
	/**
	 * Get user's inventory
	 * For now, returns mock data. In production, this would fetch from backend.
	 */
	getInventory: async (userId: string, authHeader?: Record<string, string>): Promise<Inventory> => {
		// TODO: Replace with actual API call when backend is ready
		// return http<Inventory>(`/inventory/${userId}`, {
		// 	method: 'GET',
		// 	headers: authHeader || {}
		// });
		
		// For now, return mock data
		return Promise.resolve(mockInventory);
	},

	/**
	 * Add an inventory item
	 */
	addItem: async (userId: string, item: Omit<InventoryItem, 'id' | 'userId' | 'createdAt' | 'updatedAt'>, authHeader?: Record<string, string>): Promise<InventoryItem> => {
		// TODO: Implement when backend is ready
		throw new Error('Not implemented yet');
	},

	/**
	 * Update an inventory item
	 */
	updateItem: async (userId: string, itemId: string, updates: Partial<InventoryItem>, authHeader?: Record<string, string>): Promise<InventoryItem> => {
		// TODO: Implement when backend is ready
		throw new Error('Not implemented yet');
	},

	/**
	 * Delete an inventory item
	 */
	deleteItem: async (userId: string, itemId: string, authHeader?: Record<string, string>): Promise<void> => {
		// TODO: Implement when backend is ready
		throw new Error('Not implemented yet');
	}
};
